import React, { useState, useEffect } from 'react';

const AddToHomeScreen = () => {
  const [isIos, setIsIos] = useState(false);
  const [isInStandaloneMode, setIsInStandaloneMode] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);
  const [dismissed, setDismissed] = useState(false); //  new state

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isMobile = /android|iphone|ipad|ipod/i.test(userAgent);
    //const isIosDevice = /iphone|ipad|ipod/.test(userAgent);
    //const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent); // Only Safari
    const isStandalone = 'standalone' in window.navigator && window.navigator.standalone;

    //setIsIos(isIosDevice && isSafari);
    setIsInStandaloneMode(isStandalone);

    if (!isMobile || isStandalone) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleAndroidInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        console.log('User accepted the install prompt');
      }
      setShowInstallBanner(false);
    }
  };

  const handleDismiss = () => {
    setShowInstallBanner(false);
    setDismissed(true); // mark as dismissed
  };

  //const showIosBanner = isIos && !isInStandaloneMode && !dismissed;
  const showAndroidBanner = showInstallBanner && !dismissed;

  return (
    <>
      {/* {(showIosBanner || showAndroidBanner) && ( */}
      {(showAndroidBanner) && ( 
        <div className="add-to-home-screen">
          <p>Want to add this app to your home screen?</p>
          {/* {showIosBanner ? (
            <p style={{ fontSize: '14px' }}>
              On iOS, tap the <strong>Share</strong> icon and then <strong>Add to Home Screen</strong>.
            </p>
          ) : ( */}
            <button onClick={handleAndroidInstall}>Install</button>&nbsp;
          {/* )} */}
          <button onClick={handleDismiss}>Dismiss</button>
        </div>
      )}
    </>
  );
};

export default AddToHomeScreen;
